import ExemptionRow from './ExemptionRow';

export default ExemptionRow;
